/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var receivablesPrincipalsColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Несъбр. падеж. глав.',
  render: function render(_ref) {
    var total_late_principals = _ref.total_late_principals,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late_principals"
    }, total_late_principals, " ", currency);
  }
}, {
  name: 'Бъдещи глав.',
  render: function render(_ref2) {
    var total_future_principals = _ref2.total_future_principals,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_future_principals"
    }, total_future_principals, " ", currency);
  }
}, {
  name: 'Общо',
  render: function render(_ref3) {
    var total_principals = _ref3.total_principals,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principals"
    }, total_principals, " ", currency);
  }
}];